module.exports = __webpack_public_path__ + "static/img/Congratulations.dfd27b3.png";